/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum DbGroupingBy {
    Policy = 0,
    BackupServer = 1,
    PlatformType = 2,
}
